<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        @if(loaderIcon | async){
            <app-loader></app-loader>
        }
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Product</h5>
                <ejs-tooltip id='tooltipbtnNewProduct' target="#targetNewProduct" position='LeftCenter'
                    (beforeOpen)="onBeforeOpen($event)">
                    <button id="targetNewProduct" class="btn btnAS"
                        [userPermissionHandler]="createPermissionHandlerData" (click)="openProductModal()">New</button>
                </ejs-tooltip>
            </div>
            <hr />
            <div class="container-fluid py-3">
                <div class="mb-3 d-flex gap-3 align-items-center">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" id="rdAll" type="radio" name="status" value="All"
                            [checked]="activeTab === 'All'" (change)="onTabChange('All')" />
                        <label class="form-check-label" for="rdAll">All</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" id="rdActive" type="radio" name="status" value="Active"
                            [checked]="activeTab === 'Active'" (change)="onTabChange('Active')" />
                        <label class="form-check-label" for="rdActive">Active</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" id="rdInactive" type="radio" name="status" value="Inactive"
                            [checked]="activeTab === 'Inactive'" (change)="onTabChange('Inactive')" />
                        <label class="form-check-label" for="rdInactive">Inactive</label>
                    </div>
                </div>

                <ejs-grid #gridProduct [dataSource]="data" (created)='created($event)' [allowFiltering]="true"
                    height="200" (rowSelected)="onProductRowSelected($event)">
                    <e-columns>
                        <e-column field="name" headerText="Product Name" width="180"></e-column>
                        <e-column field="category" headerText="Product Category" width="180"></e-column>
                        <e-column field="activeInactive" headerText="Active / Inactive" textAlign="Center" width="160"
                            [template]="statusTemplate"></e-column>
                        <e-column field="Delete" headerText="Delete" width="100" textAlign="Center">
                            <ng-template #template let-data>
                                <button class="btn btn-link w-100 h-100 p-0"
                                        (click)="deleteProduct(data.id); $event.stopPropagation(); $event.preventDefault()"
                                        [userPermissionHandler]="deletePermissionHandlerData">
                                        <img src="./assets/images/delete.svg" class="img-fluid" />
                                    </button>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
                <ng-template #statusTemplate let-data>
                    <span class="d-inline-block rounded-circle" [ngStyle]="{
                    width: '15px',
                    height: '15px',
                    backgroundColor: data.status === 'Active' ? 'green' : 'red'
                    }"></span>
                </ng-template>
            </div>

        </div>
    </div>
</div>

<div class="modal fade" id="productModal" #productModal tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
        <form class="modal-content" [formGroup]="productForm" (ngSubmit)="saveProduct()">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">Product</h1>
                <button type="button" class="btn-close" (click)="closeModalById('productModal')"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <label for="productName" class="form-label">Product Name<span class="text-danger">*</span></label>
                    <input type="text" class="form-control bg-light" id="productName" placeholder=""
                        formControlName="ProductName" maxlength="30">
                </div>

                <div class="mb-3">
                    <label for="productCategory" class="form-label">Product Category<span
                            class="text-danger">*</span></label>
                    <select class="form-select bg-light" id="productCategory" formControlName="ProductCategoryId">
                        <option [value]="null" disabled selected>Select Category</option>
                        @for (category of productCategory; track category.CatSeqCategoryId) {
                        <option [value]="category.CatSeqCategoryId">
                            {{ category.CatTxtCategoryDescr }}
                        </option>
                        }
                    </select>
                </div>

                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="isActive"
                        [checked]="!productForm.get('ProductInactive')?.value" (change)="onActiveChange($event)" />
                    <label class="form-check-label" for="isActive">
                        Active
                    </label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btnAS">Save</button>
                <button type="button" class="btn btn-orange" (click)="closeModalById('productModal')">Close</button>
            </div>
        </form>
    </div>
</div>